import 'css-chunksrc/client/pages/projectPage/exportsPage/wbsReport/filters/dataTypeFilter/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_7lx5l_1",
  "input": "_input_7lx5l_7",
  "toggleArrow": "_toggleArrow_7lx5l_23",
  "selectedDataTypes": "_selectedDataTypes_7lx5l_31",
  "placeholder": "_placeholder_7lx5l_40",
  "list": "_list_7lx5l_45",
  "item": "_item_7lx5l_57",
  "typeName": "_typeName_7lx5l_70",
  "opened": "_opened_7lx5l_77"
};